import React from 'react'

import CartIcon from '../CartIcon/CartIcon'
import Hamburger from '../Hamburger/Hamburger'
import { ModeLink } from '../ModeRouter/ModeRouter'
import { useAuth } from '../AuthProvider/AuthProvider'
import { RestaurantLogo } from '../RestaurantLogo/RestaurantLogo'
import { useGiftCardLinks } from '../use-gift-card-links/use-gift-card-links'
import { Link } from 'react-router-dom'
import { useRestaurant } from '../RestaurantProvider/RestaurantProvider'

import GiftCardIcon from '../../assets/gift-card.svg'
import './header.css'
import { FlagOn } from '../FeatureFlag/FeatureFlag'
import { useRouteMatch } from 'react-router'

const Header = () => {
  const { getRestaurantPath } = useRestaurant()
  const { authenticated } = useAuth()
  const { purchaseLink } = useGiftCardLinks()
  const addItem = useRouteMatch('/add/:itemGuid/:itemGroupGuid')
  const menu = useRouteMatch('/')

  const menuPage = addItem || (menu && menu.isExact)

  return (
    <div styleName='header'>
      <Hamburger />
      {menuPage &&
      <React.Fragment>
        <div styleName='centered'>
          <RestaurantLogo />
        </div>
        <div styleName='mobile cart'>
          <Link to={getRestaurantPath('cart')} >
            <CartIcon showCount />
          </Link>
        </div>
      </React.Fragment>
      }
      <div styleName='desktop'>
        {purchaseLink && (
          <FlagOn name='oo-v3-gift-card-header'>
            <div styleName='giftCardLink'>
              <GiftCardIcon />
              <a
                styleName='link'
                href={purchaseLink}
                data-testid='header-purchase-gc-link'
              >
                Buy a Gift Card
              </a>
            </div>
          </FlagOn>
        )}
        {!authenticated && (
          <React.Fragment>
            {purchaseLink && <span styleName='spacer' />}
            <ModeLink
              eventData={{
                category: 'User Account',
                action: 'Login',
                label: 'Top Nav'
              }}
              data-testid='header-login-link'
              style='secondary'
              mode='login'
            >
              Login
            </ModeLink>
            <span styleName='spacer' />
            <ModeLink
              eventData={{
                category: 'User Account',
                action: 'Create Account',
                label: 'Top Nav'
              }}
              data-testid='header-create-link'
              style='primary'
              mode='create'
            >
              Create Account
            </ModeLink>
          </React.Fragment>
        )}
      </div>
    </div>
  )
}

export default Header
